import SoftBadge from "components/SoftBadge";
import { useState, useEffect } from "react";
import ProductCell from "../components/ProductCell";
import ActionCell from "../components/ActionCell";
import PropTypes from "prop-types"; // Import PropTypes
import { API_BASE_URL } from '../../../../../services/config.js';

// Badges 
const udsInactive = (
  <SoftBadge variant="contained" color="error" size="xs" badgeContent="Inaktiv" container />
);
const udsActive = (
  <SoftBadge variant="contained" color="success" size="xs" badgeContent="Aktiv" container />
);
const udsPending = (
  <SoftBadge variant="contained" color="warning" size="xs" badgeContent="Ausstehend" container />
);

// Define a separate Cell component for the Status column
const StatusCell = ({ value }) => {
  if (value === "active") return udsActive;
  if (value === "pending") return udsPending;
  return udsInactive;
};

// Add PropTypes validation for the StatusCell component
StatusCell.propTypes = {
  value: PropTypes.string.isRequired, // Ensure 'value' is a string and required
};

const useDataTableData = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchRows = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/iaas-service/easysearch`, {
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
          console.error("API returned ERROR:", response.statusText);
          throw new Error(response.statusText);
        }

        const data = await response.json();

        if (!data) {
          setRows([]);
          return;
        }

        // Vereinfachte Verarbeitung, da wir wissen, dass die API ein Array zurückgibt
        const formattedRows = data.map((item) => {
          console.log("Processing item:", item); // Debug einzelne Items
          return {
            id: <ProductCell name={item.id} />, // Bild nur im ID-Feld
            hostname: item.hostname || "N/A",
            servicename: item.servicename || "N/A",
            sstatus: item.sstatus || "Inaktiv",
            action: <ActionCell serviceId={item.id} />,
          };
        });

        setRows(formattedRows);
      } catch (error) {
        setRows([]);
      }
    };

    fetchRows();
  }, []);

  const columns = [
    { Header: "Internal ID", accessor: "id", align: "left" },
    { Header: "Service ID", accessor: "hostname" },
    { Header: "Service Name", accessor: "servicename" },
    { 
      Header: "Status", 
      accessor: "sstatus", 
      align: "center", 
      Cell: StatusCell // Use the separate StatusCell component
    },
    { Header: "Action", accessor: "action" },
  ];

  return { columns, rows };
};

export default useDataTableData;
